<div class="flex flex-col gap-1">
  <div class="flex flex-row items-center justify-between">
    <h3 class="!m-0 !font-bold">History</h3>
    @if (totalRunCount() > 0) {
      <a
        class="text-primary-500 cursor-pointer text-xs hover:underline"
        (click)="openDialog()"
      >
        View More
      </a>
    }
  </div>

  @for (run of recentRuns(); track run.ref.path) {
    <div
      class="flex flex-row items-center gap-2 rounded px-2 py-1.5 text-xs hover:bg-slate-50"
    >
      <a
        class="flex min-w-0 grow cursor-pointer flex-row items-center gap-2 text-inherit no-underline"
        [routerLink]="historyBasePath().concat(run.ref.id)"
      >
        <div class="flex grow flex-row items-center gap-1">
          {{ run.runAt | moment | amDateFormat: 'DD MMM YYYY, h:mm a' }}
          @if (run.pinned) {
            <mat-icon class="text-primary-500 icon-xs">push_pin</mat-icon>
          }
        </div>
        <span class="shrink-0 text-slate-400">
          {{ run.runAt | fromNow$ | async }}
        </span>
      </a>

      <button
        mat-icon-button
        class="icon-sm"
        [matMenuTriggerFor]="runMenu"
        (click)="$event.stopPropagation(); $event.preventDefault()"
      >
        <mat-icon class="icon-sm">more_vert</mat-icon>
      </button>

      <mat-menu #runMenu="matMenu">
        <button mat-menu-item (click)="togglePin(run)">
          <mat-icon
            [ngClass]="run.pinned ? '!text-primary-500' : '!text-slate-400'"
          >
            push_pin
          </mat-icon>
          <span>{{ run.pinned ? 'Unpin' : 'Pin' }}</span>
        </button>
        @if (!run.pinned) {
          <button mat-menu-item (click)="archiveRun(run)">
            <mat-icon color="warn">delete</mat-icon>
            <span>Delete</span>
          </button>
        }
      </mat-menu>
    </div>
  } @empty {
    <div class="px-2 py-1 text-xs opacity-50">No report runs yet</div>
  }
</div>
